import { Injectable, Inject } from '@angular/core';
import { Subject, Observable, throwError } from 'rxjs';
import { Szme038aRequest, Szme038aResponse, Sgkd052aService } from 'sg-api';
import { map, timeout, catchError } from 'rxjs/operators';
import { ApiCommonService } from 'cbc-shared-lib';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';

@Injectable({
  providedIn: 'root'
})
export class UsedSgkd052aService {
  /** 指定された売掛金の明細情報取得のSubject */
  private _contractorDetail$: Subject<Szme038aResponse> = new Subject<Szme038aResponse>();

  /**
   * 指定された売掛金の明細情報取得のobservable提供
   *
   * @readonly
   * @memberof UsedSgkd052aService
   */
  get contractorValueChanges(): Observable<Szme038aResponse> {
    return this._contractorDetail$.asObservable();
  }

  /**
   * コンストラクタ
   * @param {SGKD052AService} sGKD052AService
   * @param {ApiCommonService} apiCommonService
   * @memberof InitialInfoService
   */
  constructor(private sgkd052aService: Sgkd052aService, private apiCommonService: ApiCommonService, @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /**
   *指定された売掛金の明細情報取得API呼び出し
   *
   * @param {*} value
   * @memberof UsedSgkd052aService
   */
  searchContractor(value: any, cdtmnyNo: string, cdtmnyRrkno: string): Observable<Szme038aResponse> {
    // リクエスト情報生成
    let request: Szme038aRequest = {
      cdtmnyNo: cdtmnyNo,
      cdtmnyRrkno: cdtmnyRrkno
    };
    return this.sgkd052aService.c17RSZME038APost(this.apiCommonService.setRequestCommon(<any>request),'response')
      .pipe(
        map(response => {
          // エラーが設定されていないかチェックする
          this.apiCommonService.checkError(response);
          this._contractorDetail$.next(response.body);
          return response.body;
        }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKD052A');
          return throwError(err.message);
        }));
  }
}